import { useState } from "react";

export default function AtividadeItem({ atividade: a, onApagar, tema: T }) {
    const [startX, setStartX] = useState(0);
    const [offsetX, setOffsetX] = useState(0);
    const [arrastando, setArrastando] = useState(false);
    const LIMIAR = 80;

    const onTouchStart = e => {
        setStartX(e.touches[0].clientX);
        setArrastando(true);
    };

    const onTouchMove = e => {
        if (!arrastando) return;
        const diff = e.touches[0].clientX - startX;
        if (diff < 0) setOffsetX(Math.max(diff, -120));
    };

    const onTouchEnd = () => {
        if (offsetX < -LIMIAR) {
            onApagar();
        } else {
            setOffsetX(0);
        }
        setArrastando(false);
    };

    const progresso = Math.min(Math.abs(offsetX) / LIMIAR, 1);

    return (
        <div style={{ position: "relative", overflow: "hidden", borderRadius: 10, marginBottom: 8 }}>
            {/* Fundo vermelho */}
            <div style={{
                position: "absolute", inset: 0,
                background: `rgba(244,67,54,${progresso * 0.9})`,
                display: "flex", alignItems: "center", justifyContent: "flex-end",
                paddingRight: 20, borderRadius: 10,
                transition: arrastando ? "none" : "background 0.3s"
            }}>
                <span style={{ fontSize: 20, opacity: progresso }}>🗑</span>
            </div>

            {/* Item */}
            <div
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                style={{
                    display: "flex", gap: 10, alignItems: "center",
                    background: T.bgCard,
                    padding: "8px 10px", borderRadius: 10,
                    transform: `translateX(${offsetX}px)`,
                    transition: arrastando ? "none" : "transform 0.3s ease",
                    cursor: "grab", userSelect: "none"
                }}
            >
                <span style={{ fontSize: 18 }}>{a.icon}</span>
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, color: T.texto }}>{a.texto}</div>
                    <div style={{ fontSize: 11, color: T.textoSecundario }}>{a.tempo}</div>
                </div>
                <span style={{ fontSize: 11, color: T.textoSecundario, opacity: 0.5 }}>← arrastar</span>
            </div>
        </div>
    );
}